module.exports = __webpack_public_path__ + "static/media/favorites.3a4a0105.svg";